import { z } from 'zod';

export const resendConfirmationCodePostRequestSchema = z.object({
  attribute_name: z.string().optional(),
  client: z.string(),
  client_secret: z.string(),
  email: z.string(),
  is_user_confirmed: z.string(),
});
